<script lang="ts">
  import { DateFilterType } from "../../helpers/types";
  import TextNew from "../TextNew.svelte";

  export let value: string;
  export let percentageChange: number | undefined = undefined;
  export let dateRangeType: DateFilterType | undefined = undefined;

  const PreviousPeriodDateFilterTitleMap: Record<DateFilterType, string> = {
    [DateFilterType.Past30Days]: "30 days",
    [DateFilterType.Past7Days]: "7 days",
    [DateFilterType.Past14Days]: "14 days",
    [DateFilterType.ThisMonth]: "month",
    [DateFilterType.Week]: "week",
    [DateFilterType.Month]: "month",
    [DateFilterType.Quarter]: "quarter",
    [DateFilterType.Custom]: "custom",
  };

  $: changeSign = percentageChange !== undefined ? Math.sign(percentageChange) : 0;
  $: percentageChangeColor =
    changeSign === -1
      ? "var(--rekki-success)"
      : changeSign === 1
      ? "var(--rekki-error)"
      : "var(--rekki-neutral-03)";

  $: isComparable = percentageChange && dateRangeType !== DateFilterType.Custom;
</script>

<div class="figures">
  <TextNew size="l">{value}</TextNew>
  {#if isComparable && dateRangeType}
    <div class="indicators">
      <TextNew as="p" size="xs" --rk-text-color={percentageChangeColor}>
        {changeSign < 0 ? "↓" : changeSign > 0 ? "↑" : ""}
        {percentageChange}%
        <TextNew
          as="span"
          size="xs"
          --text-display="inline-block"
          --rk-text-color="var(--rekki-neutral-03)"
        >
          {`v. previous ${PreviousPeriodDateFilterTitleMap[dateRangeType]}`}
        </TextNew>
      </TextNew>
    </div>
  {/if}
</div>

<style>
  .figures {
    display: flex;
    align-items: baseline;
    gap: 8px;
  }

  .indicators {
    display: flex;
    align-items: center;
    gap: 4px;
  }
</style>
